import { supabase } from '../lib/supabase';
import html2canvas from 'html2canvas';

export const screenshotService = {
  captureWebsiteScreenshot: async (url: string, forceRefresh: boolean = false): Promise<string> => {
    try {
      if (!url) {
        throw new Error('URL is required');
      }

      // Use Microlink's API with specific viewport size
      // Add cache busting when force refresh is true
      const cacheParam = forceRefresh ? `&force=true&_t=${Date.now()}` : '';
      const response = await fetch(
        `https://api.microlink.io?url=${encodeURIComponent(url)}&screenshot=true&viewport.width=1280&viewport.height=800&screenshot.fullPage=false${cacheParam}`
      );
      
      if (!response.ok) {
        throw new Error('Failed to capture screenshot');
      }

      const data = await response.json();
      let screenshotUrl = data.data.screenshot.url;
      
      // Add timestamp to URL to bust browser cache when refreshing
      if (forceRefresh) {
        screenshotUrl += `?v=${Date.now()}`;
      }
      
      return screenshotUrl;
    } catch (error) {
      console.error('Screenshot error:', error);
      return '/images/placeholder-screenshot.png';
    }
  }
};